import dataMap from "./data.js";
import Config from "@/config";
export const getTenantBaseConfig = () => {
  if (Config.isDevelopment) {
    // return dataMap.get("https://cus-remotesales-dev.linkioapp.com");
    return dataMap.get("https://prp-remotesales.brioni.cn");
  }

  return dataMap.get(location.origin);
};
